export const PAGE_SIZE_OPTIONS = [15, 25, 50, 100];
export const MIN_PAGE_SIZE = PAGE_SIZE_OPTIONS[0];
